import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { VersionCheckService } from './services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  private dropdownAnchors = new WeakMap<HTMLElement, { menu: HTMLElement; placeholder: Comment }>();

  constructor(
    private titleService: Title,
    private metaService: Meta,
    public versionCheck: VersionCheckService
  ) {}


  ngOnInit(): void {
    this.fixSafariDropdownClipping();

    // Start version polling (checks every 5 minutes)
    this.versionCheck.init();

    // Set the CSS variable dynamically
    document.documentElement.style.setProperty('--active-border-color', environment.primaryColor);

    // Update the title
    this.titleService.setTitle(`${environment.projectName} Admin`);

    // Update meta tags
    this.metaService.updateTag({
      name: 'description',
      content: `${environment.projectName} - Admin Dashboard`,
    });

    // Change favicon
    const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
    if (favicon) {
      favicon.href = environment.projectFavIcon;
    }

    // Dynamically load theme CSS
    const themeLink = document.createElement('link');
    themeLink.rel = 'stylesheet';
    themeLink.href = environment.projectTheme;
    document.head.appendChild(themeLink);
  }

  // Safari clips position:fixed elements to the nearest ancestor with overflow != visible
  // (e.g. .table-responsive), unlike Chrome/Firefox. Moving the action-menu dropdowns to
  // <body> while open removes them from that clipping ancestor entirely, and Popper
  // (Bootstrap's dropdown engine) repositions them correctly regardless of DOM location.
  private fixSafariDropdownClipping(): void {
    document.addEventListener('show.bs.dropdown', (event: Event) => {
      const toggle = event.target as HTMLElement;
      const menu = toggle.parentElement?.querySelector(
        ':scope > .dropdown-menu.dropdown-menu-custom'
      ) as HTMLElement | null;
      if (!menu) return;

      const placeholder = document.createComment('dropdown-menu-anchor');
      menu.after(placeholder);
      document.body.appendChild(menu);
      this.dropdownAnchors.set(toggle, { menu, placeholder });
    });

    document.addEventListener('hidden.bs.dropdown', (event: Event) => {
      const toggle = event.target as HTMLElement;
      const anchor = this.dropdownAnchors.get(toggle);
      if (!anchor) return;
      this.dropdownAnchors.delete(toggle);

      if (anchor.placeholder.isConnected) {
        anchor.placeholder.replaceWith(anchor.menu);
      } else {
        anchor.menu.remove();
      }
    });
  }
}
